import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import GetStarted from './pages/GetStarted';
import Legal from './pages/Legal';
import CompliancePolicy from './pages/CompliancePolicy';
import { Toaster } from './components/ui/toaster';

// Admin imports
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminIntegrations from './pages/admin/Integrations';
import AdminLeads from './pages/admin/Leads';
import AdminCampaigns from './pages/admin/Campaigns';
import AdminUsers from './pages/admin/Users';
import AdminFAQs from './pages/admin/FAQs';
import AdminInquiries from './pages/admin/Inquiries';
import AdminAuditLogs from './pages/admin/AuditLogs';
import AdminSettings from './pages/admin/Settings';
import PaymentsDashboard from './pages/admin/payments/Dashboard';
import PaymentsTransactions from './pages/admin/payments/Transactions';
import PaymentsSettings from './pages/admin/payments/Settings';
import CmsPages from './pages/admin/cms/Pages';
import CmsSections from './pages/admin/cms/Sections';
import CmsSettings from './pages/admin/cms/Settings';
import CmsPageEditor from './pages/admin/cms/PageEditor';

// Public website layout wrapper
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <div className="h-32"></div>
    {children}
    <Footer />
    <CookieBanner />
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin Routes - No public header/footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/integrations" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <AdminIntegrations />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/leads" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <AdminLeads />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/campaigns" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <AdminCampaigns />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/users" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <AdminUsers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/faqs" 
              element={
                <ProtectedRoute>
                  <AdminFAQs />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/inquiries" 
              element={
                <ProtectedRoute>
                  <AdminInquiries />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/audit-logs" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <AdminAuditLogs />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/payments" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <PaymentsDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/payments/transactions" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <PaymentsTransactions />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/payments/settings" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <PaymentsSettings />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/cms" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <CmsPages />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/cms/sections" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <CmsSections />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/cms/settings" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <CmsSettings />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/cms/pages/:pageId/edit" 
              element={
                <ProtectedRoute allowedRoles={['owner', 'admin']}>
                  <CmsPageEditor />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/*" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />

            {/* Public Routes - With header/footer */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
            <Route path="/legal" element={<PublicLayout><Legal /></PublicLayout>} />
            <Route path="/terms" element={<PublicLayout><Terms /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
            <Route path="/compliance-policy" element={<PublicLayout><CompliancePolicy /></PublicLayout>} />
            <Route path="/get-started" element={<PublicLayout><GetStarted /></PublicLayout>} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;